import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/dictionary-system";

export const pagingDictionarySystems = (searchObject) => {
  var url = API_PATH + "/pading-dictionary-system";
  return axios.post(url, searchObject);
};

export const getDictionarySystem = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createDictionarySystem = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editDictionarySystem = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteDictionarySystem = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};
